import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { getSearchMyBookingCustomerRequestsCount } from "app/pages/Account/SearchMyBooking/searchMyBookingSelector";
import AccountAsideMenuUnauthenticated from "app/pages/Account/AccountAsideMenu/AccountAsideMenuUnauthenticated";

const AccountAsideMenuUnauthenticatedContainer = ({ onItemClick = () => {} }) => {
	const customerRequestsCount = useSelector(getSearchMyBookingCustomerRequestsCount) || 0;
	const myBooking = useSelector(state => state.searchMyBooking.booking) || {};

	return (
		<AccountAsideMenuUnauthenticated
			onItemClick={onItemClick}
			showCustomerRequestNotification={customerRequestsCount > 0}
			myBooking={myBooking}
		/>
	);
};

AccountAsideMenuUnauthenticatedContainer.propTypes = {
	customerRequestsCount: PropTypes.number,
	onItemClick: PropTypes.func,
	myBooking: PropTypes.object,
};

export default AccountAsideMenuUnauthenticatedContainer;
